import React from 'react';
// import extendedLogo1 from "../images/extendedLogo1.png"
import useWindowSize from "../utils";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    footer: {
        bottom: "0px",
        left: "0px",
        right: "0px",   
        borderTop: "3px solid black",
        display: "flex",
        alignItems: "center",
        Zindex: "-1", /* Stay on top of everything */
        justifyContent: "center",
        width: "100%",
        marginTop: "2%",
        backgroundColor: "#F4F4F4",
        textAlign: "center"
    },
    right: {
        display: "flex",
        float: "right",
        margin: "auto",
        flexDirection: "column",
        alignItems: "center",
        marginRight: "10px"
    },
    main: {
        textDecoration: "none",
        color: "black",
    }
}));

export default function Footer() {
    const classes = useStyles();
    const { width } = useWindowSize();

    return (
        <div 
            className={classes.footer} 
            style={width < 550 ? 
                {flexDirection: "column"} : {flexDirection: "row"}}>
            <a className={classes.main} href="/"><h1>Azienda agricola Morabito</h1> </a>

            <div className={classes.right} >
                <p style={{ marginBottom: "0px" }}>Progetto finaziato in concorso delle risorse FEASR-PSR CALABRIA</p>
                <p style={{ marginTop: "0px", marginBottom: "0px" }}>2014/2020. MISURA 6, Intervento 6.1.1 e Misura 4, Intervento 4.1.2; 4.1.3 – CUP: J72H18000490002</p>
                <p style={{ marginTop: "0px" }}>Copyright © 2021 Azienda Agricola Morabito – P.IVA: 03115730800 </p>
            </div>
        </div>
    );
}